// This file was auto-generated by __GENERATE_CHAIN_PRESETS__.js. Do not edit manually.

import { astarZkyoto as _astarZkyoto } from 'viem/chains'
import { createCommon } from '../createCommon.js'

/**
 * Creates a common configuration for the astarZkyoto chain.
 * @type {import('../Common.js').Common}
 * @description
 * Chain ID: 6038361
 * Chain Name: Astar zkEVM Testnet zKyoto
 * Default Block Explorer: https://zkyoto.explorer.startale.com
 * Default RPC URL: https://rpc.startale.com/zkyoto
 * @example
 * import { createMemoryClient } from 'tevm'
 * import { astarZkyoto } from 'tevm/common'
 * import { http } from 'tevm'
 *
 * const client = createMemoryClient({
 *   common: astarZkyoto,
 *   fork: {
 *     transport: http({ url: 'https://example.com' })({})
 *   },
 * })
 */
export const astarZkyoto = createCommon({
	..._astarZkyoto,
	loggingLevel: 'warn',
	eips: [],
	hardfork: 'prague',
})
